import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.error.cause.js";
import { ref, reactive, toRefs, onActivated } from "vue";
import apis from "@/api";
export default {
  name: "AccountAdd",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  setup(props, context) {
    const userForm = ref(null);
    const data = reactive({
      cities: [],
      userInfo: {},
      disabled: false,
      rules: {
        userId: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }, {
          validator: validateUserId,
          trigger: "blur"
        }],
        empName: [{
          required: true,
          message: "请输入用户姓名",
          trigger: "blur"
        }],
        mobile: [{
          required: true,
          message: "请输入手机号码",
          trigger: "blur"
        }]
      }
    });
    function validateUserId(rule, value, callback) {
      if (!data.userInfo.id && value) {
        apis.checkUserId({
          userId: value
        }).then(res => {
          if (res.success) {
            if (res.data) {
              callback(new Error("账号已存在，请重新输入"));
            } else {
              callback();
            }
          } else {
            callback(new Error(res.msg));
          }
        });
      } else {
        callback();
      }
    }
    const close = () => {
      context.emit("update:visible", false);
    };
    const hanldeSubmit = () => {
      userForm.value.validate(valid => {
        if (valid) {
          if (data.userInfo.id) {
            apis.editUser(data.userInfo).then(res => {
              if (res.success) {
                ElMessage.success("账号修改成功");
                context.emit("success");
                context.emit("update:visible", false);
              } else {
                ElMessage.error(res.msg);
              }
            });
          } else {
            apis.addUser(data.userInfo).then(res => {
              if (res.success) {
                ElMessage.success("账号新增成功");
                context.emit("success");
                context.emit("update:visible", false);
              } else {
                ElMessage.error(res.msg);
              }
            });
          }
        }
      });
    };
    const setUserInfo = userInfo => {
      data.userInfo = userInfo;
      data.disabled = userInfo.userType === "0" || userInfo.userType === "1" ? true : false;
    };
    const setCities = cities => {
      data.cities = cities;
    };
    return {
      ...toRefs(data),
      userForm,
      close,
      hanldeSubmit,
      setUserInfo,
      setCities
    };
  }
};